/**
 *    @author: Andrew Sheen
 *    @since:  2020-10-30
 */

import { Router } from '@angular/router';
import { TimerService } from 'src/refresh/service/timer-service';
import { InputData } from '../data/input-data';
import { PageConstComponent } from './page-const.component';

export class PageBaseComponent extends PageConstComponent {

     protected nextURL:string;
     protected prevURL:string;

     static isTest:boolean;

     constructor( protected router: Router,protected timerService:TimerService) { 
           super(); 
      }

     public setNextPage(nextURL:string,prevURL:string) {

            this.nextURL = "/"+nextURL;
            this.prevURL = "/"+prevURL;
     }

     public onPreviousClick() {
            this.timerService.reset();
            //this.router.navigate([this.prevURL]);  
            window.history.back();
     }
        
     public onNextClick() {
            this.timerService.reset();
            this.router.navigate([this.nextURL]);  
     }
     
     public getNextURL():string {
            return this.nextURL;
     }

     public ngAfterViewInit() {
            if ( !PageBaseComponent.isTest ) return;
            let id:any =  document.getElementsByClassName("btn-next");
            if ( id && id.length > 0 ) {
                  id[0].focus();
            }
     }
}


